// extracted by mini-css-extract-plugin
export default {"appDropDown":"AppDropDownOverride_appDropDown__U3YOD","icon":"AppDropDownOverride_icon__Xg7lV","appName":"AppDropDownOverride_appName__tKiVB"};